import { render, staticRenderFns } from "./TIPO_LOGIN_PORTAL.vue?vue&type=template&id=795c7248"
import script from "./TIPO_LOGIN_PORTAL.vue?vue&type=script&lang=js"
export * from "./TIPO_LOGIN_PORTAL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports